import { Observable, forkJoin, of } from 'rxjs';

/**
 * `forkJoin` that also emits for an empty list.
 *
 * @remarks
 * `forkJoin([])` completes without ever emitting `next`, so anything chained
 * after it silently never runs. This emits `[]` instead.
 */
export function forkJoinOrEmpty<T>(
  operations: Observable<T>[],
): Observable<T[]> {
  if (operations.length === 0) {
    return of([]);
  }

  return forkJoin(operations);
}
